/* eslint-disable no-useless-escape */
// There are a lot of youtube link formats
// https://gist.github.com/rodrigoborgesdeoliveira/987683cfbfcc8d800192da1e73adc486
const ytIdRegex = '(?<id>[a-zA-Z0-9-_]+)';
// dQw4w9WgXcQ
const ytRegex = new RegExp(`^${ytIdRegex}$`);
// www.youtube.com/watch?v=dQw4w9WgXcQ
const ytRegex1 = new RegExp(`youtube\.com\/watch\\?v=${ytIdRegex}`);
// youtube.be/dQw4w9WgXcQ
const ytRegex2 = new RegExp(`youtu\.be\/${ytIdRegex}`);
// www.youtube.com/v/dQw4w9WgXcQ
// www.youtube.com/e/dQw4w9WgXcQ
// www.youtube.com/embed/dQw4w9WgXcQ
const ytRegex3 = new RegExp(`youtube\.com\/(v|e|embed)\/${ytIdRegex}`);

const chooseRegex = (youtube) =>
  [ytRegex, ytRegex1, ytRegex2, ytRegex3].find((regex) => youtube.match(regex));

const youtubeUrlPrefix = 'https://www.youtube.com/embed/';
const youtubeNoCookieUrlPrefix = 'https://www.youtube-nocookie.com/embed/';

export const youtubeIdFromInput = (youtube) => youtube.match(chooseRegex(youtube))?.groups?.id;

export const youtubeUrlFromInput = (youtube) => youtubeUrlPrefix + youtubeIdFromInput(youtube);

export const youtubeNoCookieUrlFromInput = (youtube, queryString = '') => {
  const youtubeId = youtube ? youtubeIdFromInput(youtube) : null;

  if (!youtubeId) return null;

  return `${youtubeNoCookieUrlPrefix}${youtubeId}${queryString ? `?${queryString}` : ''}`;
};
